import { ListItemButton, Typography } from '@mui/material';
import { getPatients } from 'apis/admin';
import usePatient from 'store/patient/usePatient';
import useStudent from 'store/student/useStudent';
import MuiAutocomplete from 'components/MuiAutocomplete';
import { Dot } from 'styles/dot';

interface IOption {
  patient_id: string;
  patient_virtual_id?: string;
  name: string;
  age: string;
  nursing_record_exists?: number;
  other_record_exists?: number;
  patient_private?: boolean;
}

const CollegePatientList = ({ user_id }: { user_id: number }) => {
  const { onSelectedPatient } = usePatient();
  const { student_uuid } = useStudent();

  const optionLabel = ({ patient_id, patient_virtual_id, name }: IOption) =>
    `${patient_virtual_id || patient_id} ${name}`;

  const Option = ({
    patient_id,
    patient_virtual_id,
    name,
    age,
    patient_private,
    ...props
  }: IOption) => {
    const displayPatientId = patient_virtual_id || patient_id;

    // patient_private가 true일 경우 스타일 적용
    const customStyles = patient_private
      ? { backgroundColor: '#fff', color: '#00000080' }
      : {};

    return (
      <ListItemButton {...props} sx={{ gap: 0.5, ...customStyles }}>
        <Typography variant="subtitle2" color="inherit">
          {displayPatientId}
        </Typography>
        <Typography variant="caption" color="inherit">
          {name}
        </Typography>
        <Typography variant="caption" color="inherit">
          {age}
        </Typography>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          {props.nursing_record_exists === 1 && <Dot $bg="#14855B" />}
          {props.other_record_exists === 1 && <Dot $bg="#9C57C7" />}
        </div>
      </ListItemButton>
    );
  };

  return (
    <MuiAutocomplete
      variant="standard"
      valueKey="patient_id"
      listKey="admin_patients"
      placeholder="환자 검색"
      noOptionsText="검색한 환자가 없습니다 다른 환자 이름을 입력해주세요"
      getOptionLabel={optionLabel}
      renderOption={(props, option) => <Option {...props} {...option} />}
      onChange={onSelectedPatient}
      getApi={request => getPatients({ user_id, ...request })}
    />
  );
};

export default CollegePatientList;
